import { cva, VariantProps } from "class-variance-authority";
import Link from "next/link";
import { ComponentProps } from "react";

import { cn } from "@/utils/cn";

const buttonVariant = cva(
  "text-center hover:brightness-[.95] disabled:opacity-50 transition-[filter] duration-200 rounded-md font-normal text-16 whitespace-nowrap leading-none",
  {
    variants: {
      color: {
        primary: "bg-primary text-white",
        gray: "bg-lightgray text-gray",
        white: "bg-white text-gray",
      },
      size: {
        sm: "px-4 py-2 text-14",
        md: "px-5 py-2.5 text-16",
      },
      border: {
        gray: "border border-gray-300",
      },
    },
    defaultVariants: {
      color: "primary",
      size: "md",
    },
  },
);

type ButtonProps = VariantProps<typeof buttonVariant> & (ComponentProps<"button"> | ComponentProps<typeof Link>);

function Button({ className, color, size, border, children, ...props }: ButtonProps) {
  const CN = cn(buttonVariant({ color, size, border }), className);

  if ("href" in props) {
    return (
      <Link className={CN} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <button className={CN} {...props}>
      {children}
    </button>
  );
}

export default Button;
